import React, { useState } from "react";
import { format } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "../UIElements/Popover";
import { Calendar } from "../UIElements/Calendar";
import { Icon } from "../UIElements/Icon";
import { cn } from "../../../lib/utils";

const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const CampaignDatePicker = ({
  value,
  onChange,
  placeholder = "Select date",
  minDate,
  className,
}) => {
  const [open, setOpen] = useState(false);

  const selectedDate = parseLocalDate(value);

  const handleSelect = (date) => {
    if (date) {
      const formattedDate = format(date, "yyyy-MM-dd");
      onChange(formattedDate);
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className={cn(
            "hover:bg-gray-750 flex cursor-pointer items-center gap-2 rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white transition-colors focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none",
            className,
          )}
        >
          <Icon name="Calendar" className="h-4 w-4 text-blue-500" />
          <span className={value ? "text-white" : "text-gray-400"}>
            {value ? format(parseLocalDate(value), "dd/MM/yyyy") : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto border-gray-700 bg-gray-900 p-0"
        align="start"
        onClick={(e) => e.stopPropagation()}
      >
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={handleSelect}
          disabled={minDate ? { before: minDate } : undefined}
          className="bg-gray-900 text-white [&_[data-selected-single=true]]:bg-blue-600 [&_[data-selected-single=true]]:text-white"
          formatters={{
            formatWeekdayName: (date) => {
              const weekdays = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
              return weekdays[date.getDay()];
            },
          }}
          classNames={{
            today: "ring-2 ring-blue-500 ring-inset rounded-md",
            outside: "text-gray-600",
            disabled: "text-gray-600 opacity-50",
            caption_label: "text-white",
            weekdays: "flex justify-between",
            weekday: "text-gray-400 text-center flex-1 w-8",
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default CampaignDatePicker;
